import React, { useState, useEffect, useRef } from 'react';
import { Container, Grid, Paper } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
const CustomContainer = HOCLoader(Container);

export const PaysprintURLRedirect = () => {
    const formRef = useRef(null);
    const location = useLocation();
    const classes = commonStyle();
    const RedirectURL = location.state.RedirectURL;

    useEffect(() => {
        formRef.current.submit();
    }, []);

    return (
        <CustomContainer>
            <Paper className={classes.PaperStyle}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        Please wait .....
                    </Grid>
                </Grid>
            </Paper>
            <form
                ref={formRef}
                method="post"
                action={RedirectURL}
                target="_blank"
            >
                <input
                    type="submit"
                    value="Redirect"
                    style={{ display: 'none' }}
                />
            </form>
        </CustomContainer>
    );
};
